import type { ReactNode } from 'react';
import { useHintSeen, type HintKey } from '../lib/hints';

/**
 * The first-move one-liner (card Rl0vzkZ2hdAe).
 *
 * Identical markup to the old inline `<p className="tab-hint">` — same class,
 * same id, so the tooltip trigger and every walk selector still resolve — but
 * it stops rendering the moment `markHintSeen` records the action it names.
 * Renders `null` when seen: the heading below takes the space, nothing leaves
 * a stub behind.
 */
export function TabHint({
  id,
  hintKey,
  children,
}: {
  /** Stable DOM id — walks and in-page anchors target it. */
  id: string;
  hintKey: HintKey;
  children: ReactNode;
}) {
  const seen = useHintSeen(hintKey);
  if (seen) return null;
  return (
    <p className="tab-hint" id={id}>
      {children}
    </p>
  );
}
